import React from 'react';

// =============================================
// CYCLE CONFIRM MODAL COMPONENT
// =============================================

export function CycleConfirmModal({ 
    showCycleConfirm, 
    setShowCycleConfirm, 
    cycleResetStatus, 
    handleCloseCycle,
    cycleOpenedAt,
    currentCycle 
}) {
    if (!showCycleConfirm) return null;

    return (
        <div className="cycle-confirm-overlay" onClick={() => cycleResetStatus === 'idle' && setShowCycleConfirm(false)}>
            <div className="cycle-confirm-modal" onClick={e => e.stopPropagation()}>
                <div className="cycle-confirm-icon">🔄</div>
                <div className="cycle-confirm-title">Start New Budget Cycle</div>
                <div className="cycle-confirm-body">
                    You&apos;re about to close the current cycle and begin <strong style={{ color: 'var(--primary)' }}>{currentCycle?.label}</strong>.
                </div>
                <div className="cycle-confirm-checklist">
                    <div className="cycle-confirm-check-item"><span>☁️</span><span>Export actuals to <strong>Google Drive</strong> as <code style={{ background: 'rgba(255,255,255,0.08)', padding: '1px 5px', borderRadius: '4px', fontSize: '11px' }}>iplanner-budget-{cycleOpenedAt}.json</code></span></div>
                    <div className="cycle-confirm-check-item"><span>📁</span><span>Archive current actuals to <strong>Budget History</strong> tab</span></div>
                    <div className="cycle-confirm-check-item"><span>🔁</span><span>Reset all <strong>actual spend</strong> and <strong>spend logs</strong> to zero</span></div>
                    <div className="cycle-confirm-check-item"><span>✅</span><span>Budget <strong>categories and amounts</strong> are preserved</span></div>
                </div>
                <div className="cycle-confirm-btn-row">
                    <button
                        className="cycle-confirm-cancel-btn"
                        onClick={() => setShowCycleConfirm(false)}
                        disabled={cycleResetStatus === 'exporting'}
                    >
                        Cancel
                    </button>
                    <button
                        className="cycle-confirm-go-btn"
                        onClick={handleCloseCycle}
                        disabled={cycleResetStatus === 'exporting'}
                    >
                        {cycleResetStatus === 'exporting' ? '⏳ Exporting to Drive…' :
                            cycleResetStatus === 'done' ? '✅ Done!' :
                                '☁️ Export & Reset'}
                    </button>
                </div>
                {cycleResetStatus === 'error' && (
                    <div style={{ marginTop: '10px', fontSize: '12px', color: '#fca5a5', textAlign: 'center' }}>
                        ⚠️ Drive export failed — cycle was still reset and archived locally.
                    </div>
                )}
            </div>
        </div>
    );
}
